import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column text-center" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { defineComponent, withDefaults, computed, ComputedRef } from 'vue';

interface TextLabel {
  text?: string,
  color?: string,
  fontSize?: number,
  fontWeight?: string,
  lineHeight?: number,
}

interface TextLogo {
  title: TextLabel,
  subTitle: TextLabel,
}

/* LIFECYCLE: PROPS */
// link: https://vuejs.org/guide/typescript/composition-api.html#typing-component-props

export default /*#__PURE__*/_defineComponent({
  __name: 'TextLogo',
  props: {
    title: { default: () => ({ text: 'LINKAGE', color: 'primary', fontSize: 60, fontWeight: 'bold', lineHeight: 1.1 }) },
    subTitle: { default: () => ({ text: 'PROXY  SERVER', color: 'primary', fontSize: 60, fontWeight: 'normal', lineHeight: 1.1 }) }
  },
  setup(__props: any) {

const props = __props as { title: TextLabel, subTitle: TextLabel };

defineComponent({ name: 'CwTextLogo' });

/* LIFECYCLE: DECLARE VARIABLES */


/* LIFECYCLE: METHODS */
const getFontSize = (n?: number): number => (n != null && n > 0 && /\d/g.test(n.toString()) ? n : 60);

const getFontWeight = (s?: string): string => (s ?? 'bold');

const getLineHeight = (n?: number): string => `${(n != null && n >= 0 ? n : 1.1)}`;

const calWidthText = (text: string, fontSize: number, fontWeight: string = 'normal') => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (ctx == null) return 0;
  ctx.font = `${fontWeight} ${fontSize}px "Roboto", sans-serif`;
  // ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
  return ctx.measureText(text).width;
};

/* LIFECYCLE: COMPUTED */
// ex.: computed(callback: (): :type  => {...})
const fontSize1: ComputedRef<number> = computed((): number => {
  const size1 = getFontSize(props.title.fontSize ?? 0);
  return size1;
});

const fontSize2: ComputedRef<number> = computed(() => {
  if (!props.subTitle?.text) return 0;

  let fontSize = props.subTitle.fontSize ?? 0;
  if (!props.title.fontSize) return fontSize;

  const w1 = calWidthText(props.title.text ?? '', getFontSize(props.title.fontSize ?? 0), 'bold');
  let w2 = calWidthText(props.subTitle.text ?? '', fontSize);
  if (w1 === w2) return fontSize;

  if (w1 > w2) {
    const increase = 0.1;
    do {
      fontSize += increase;
      w2 = calWidthText(props.subTitle.text ?? '', fontSize);
    } while (w1 > w2);
  } else {
    const increase = -0.1;
    do {
      fontSize += increase;
      w2 = calWidthText(props.subTitle.text ?? '', fontSize);
    } while (w1 < w2);
  }

  return Math.floor(fontSize);
});

/* LIFECYCLE: MOUNTED */
// ex.: onMounted(callback: () => void)
// ...

/* LIFECYCLE: EXPOSE */
// ex.: defineExpose(:data)
// ...

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(`text-${__props.title.color}`),
      style: _normalizeStyle(`font-size: ${_unref(fontSize1)}px; font-weight: ${getFontWeight(__props.title.fontWeight)}; line-height: ${getLineHeight(__props.title.lineHeight)};`),
      innerHTML: __props.title.text
    }, null, 14, _hoisted_2),
    _createElementVNode("span", {
      class: _normalizeClass(`text-${__props.title.color}-opacity-7`),
      style: _normalizeStyle(`font-size: ${_unref(fontSize2)}px; font-weight: ${getFontWeight(__props.subTitle.fontWeight)}; line-height: ${getLineHeight(__props.subTitle.lineHeight)};`),
      innerHTML: __props.subTitle.text
    }, null, 14, _hoisted_3)
  ]))
}
}

})